<template>
  <layout>
    <rdkm-title>
      {{ $t('Анкеты доноров') }}
      <span class="d-flex float-right"> 
        <import-modal></import-modal>
      </span>
    </rdkm-title>
    <div class="tile">
      <filter-form
        :labId="filterQuery.labId"
        :firstName="filterQuery.firstName"
        :lastName="filterQuery.lastName"
        :patronymicName="filterQuery.patronymicName"
        :gender="filterQuery.gender"
        :statuses="filterQuery.statuses"
        :certificateNumberFrom="filterQuery.certificateNumberFrom"
        :certificateNumberTo="filterQuery.certificateNumberTo"
        :ageFrom="filterQuery.ageFrom"
        :ageTo="filterQuery.ageTo"
        :weightFrom="filterQuery.weightFrom"
        :weightTo="filterQuery.weightTo"
        :isBloodDonor="filterQuery.isBloodDonor"
        :createdFrom="filterQuery.createdFrom"
        :createdTo="filterQuery.createdTo"
        :activatedFrom="filterQuery.activatedFrom"
        :activatedTo="filterQuery.activatedTo"
        :dateOfBirthFrom="filterQuery.dateOfBirthFrom"
        :dateOfBirthTo="filterQuery.dateOfBirthTo"
        :receiptInFrom="filterQuery.receiptInFrom"
        :receiptInTo="filterQuery.receiptInTo"
        :signedAtFrom="filterQuery.signedAtFrom"
        :signedAtTo="filterQuery.signedAtTo"
        :statusDateFrom="filterQuery.statusDateFrom"
        :statusDateTo="filterQuery.statusDateTo"
        :phone="filterQuery.phone"
        :email="filterQuery.email"
        :regionIds="filterQuery.regionIds"
        :initialDeletionReasonIds="filterQuery.initialDeletionReasonIds"
        :biomaterialSampleIds="filterQuery.biomaterialSampleIds"
        :deletionReasonIds="filterQuery.deletionReasonIds"
        :learnedFromIds="filterQuery.learnedFromIds"
        :nationalities="filterQuery.nationalities"
        :city="filterQuery.city"
        :hasDiseases="filterQuery.hasDiseases"
        :isPriority="filterQuery.isPriority"
        :hasMail="filterQuery.hasMail"
        :hasNationality="filterQuery.hasNationality"
        :hasBloodTransfusion="filterQuery.hasBloodTransfusion"
        :hasSurgery="filterQuery.hasSurgery"
        :lrOrganizationId="filterQuery.lrOrganizationId"
        :entryType="filterQuery.entryType"
        :incomeCity="filterQuery.incomeCity"
        :entryMedicalOfficeId="filterQuery.entryMedicalOfficeId"
        :entryActionId="filterQuery.entryActionId"
        :noConnection="filterQuery.noConnection"
        v-on:reset="$refs.grid.filter(reset)"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <rdkm-grid
        ref="grid"
        :state="filterQuery"
        :class="'donors-form-grid'"
        :emptyDataLabel="$t('Отсутствуют доноры')"
        :url-prefix="'pmdd'"
        v-if="!$auth.user().isLab"
      >
      <grid-column
          name="idd"
          :title="$t('IDD')"
          width="120"
          :tooltipTitle="' '"
          :className="(row) => getStatusColorClass(row)"
          cell="edit-cell"
          :url="(row) => `/donorsForm/${row.id}`"
        ></grid-column>
        <grid-column
          :title="$t('Дата поступ.')"
          width="140"
          :className="(row) => getStatusColorClass(row)"
          name="receipt_in_ano_at_from_certificate"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          :title="$t('ФИО')"
          width="285"
          :className="(row) => getStatusColorClass(row)"
          key="last_name"
          name="full_name"
        ></grid-column>
        <grid-column
          :title="$t('Пол')"
          width="99"
          :className="(row) => getStatusColorClass(row)"
          name="gender_name"
        ></grid-column>
        <grid-column
          key="age"
          :title="$t('Возраст')"
          width="99"
          :className="(row) => getStatusColorClass(row)"
          name="age"
        ></grid-column>
        <grid-column
          :title="$t('№ акта из лаб.')"
          width="140"
          :className="(row) => getStatusColorClass(row)"
          name="certificate_number"
        ></grid-column>
        <grid-column
          key="status"
          :title="$t('Статус')"
          width="140"
          :className="(row) => getStatusColorClass(row)"
          name="status_name"
        ></grid-column>
        <grid-column
          key="final_status_changed_at"
          :title="$t('Дата статуса')"
          width="120"
          :className="(row) => getStatusColorClass(row)"
          name="final_status_changed_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="activate_date"
          :title="$t('Дата активации')"
          width="170"
          :className="(row) => getStatusColorClass(row)"
          name="activate_date"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="timeout"
          :title="$t('Тайм-аут')"
          v-if="$auth.user().isDoctor"
          width="100"
          :className="(row) => getStatusColorClass(row)"
          name="timeout"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="edited_at"
          :title="$t('Дата изменения')"
          width="170"
          :className="(row) => getStatusColorClass(row)"
          name="edited_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="created_by_user_name"
          :title="$t('Оператор')"
          :className="(row) => getStatusColorClass(row)"
          name="created_by_user_name"
        ></grid-column>
        <grid-column name="DELETE" :className="(row) => getStatusColorClass(row)" v-if="$auth.user().isRdkm || $auth.user().isLr" :urlPrefix="'pmdd'" cell="delete-cell"></grid-column>
      </rdkm-grid>
      <rdkm-grid
        ref="grid"
        :state="filterQuery"
        :class="'donors-form-grid'"
        :emptyDataLabel="$t('Отсутствуют доноры')"
        :url-prefix="'pmdd'"
        v-else
      >
      <grid-column
          name="idd"
          :title="$t('IDD')"
          width="120"
          :className="(row) => getStatusColorClass(row)"
          cell="edit-cell"
          :url="(row) => `/donorsForm/${row.id}`"
        ></grid-column>
        <grid-column
          :title="$t('№ акта из лаб.')"
          width="140"
          :className="(row) => getStatusColorClass(row)"
          name="certificate_number"
        ></grid-column>
        <grid-column
          :title="$t('Поступ. в лаб.')"
          width="130"
          :className="(row) => getStatusColorClass(row)"
          name="receipt_in_laboratory_at_from_certificate"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="signed_at"
          :title="$t('Зап. анкеты')"
          width="130"
          :className="(row) => getStatusColorClass(row)"
          name="signed_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          :title="$t('Пол')"
          width="99"
          :className="(row) => getStatusColorClass(row)"
          name="gender_name"
        ></grid-column>
        <grid-column
          key="age"
          :title="$t('Возраст')"
          width="99"
          :className="(row) => getStatusColorClass(row)"
          name="age"
        ></grid-column>
        <grid-column
          key="status"
          :title="$t('Статус')"
          width="140"
          :className="(row) => getStatusColorClass(row)"
          name="status_name"
        ></grid-column>
        <grid-column
          key="final_status_changed_at"
          :title="$t('Дата статуса')"
          width="130"
          :className="(row) => getStatusColorClass(row)"
          name="final_status_changed_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="edited_at"
          :title="$t('Дата изменения')"
          width="170"
          :className="(row) => getStatusColorClass(row)"
          name="edited_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<style scoped>
.include-deleted {
  padding-top: 3px !important;
  font-size: 16px;
  line-height: 0;
}

input[type='file'] {
  display: none;
}
.custom-file-upload {
  color: #6c757d;
  border-radius: 3px;
  border: 2px solid #6c757d;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 12px;
  margin-left: 10px;
  cursor: pointer;
}
.custom-file-upload:hover {
  color: white;
  background-color: #6c757d;
}

.swal-modal {
  width: 850px !important;
}
</style>

<script>
import FilterForm from './Filter.vue';
import ImportModal from './ImportModal.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import axios from 'axios';
import onScan from 'onscan.js';
import Constants from '../../constants';
import { EventBus } from '../../event-bus';
import DonorService from '../../services/donor.service.js';


export default {
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'import-modal': ImportModal,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
  data() {
    return {
      file: '',
      patient: null,
      filterQuery: {},
    };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
    let self = this;
    if (onScan.isAttachedTo(document) == false) {
        if(this.filterQuery.redirectCode) {
          axios.get('/pmdd/DonorsForm/getByLabId?labId=' + this.filterQuery.redirectCode).then((response) => {
            if(response.data.id) {
              self.$router.push('/donorsForm/' + response.data.id);
            }
          });
        }
        onScan.attachTo(document, {
            suffixKeyCodes: [13],
            reactToPaste: false,
            onScan: function(sCode) {
              EventBus.$emit('showThrobber');
              axios.get('/pmdd/DonorsForm/getByLabId?labId=' + sCode).then((response) => {
                if(response.data.id) {
                  self.$router.push('/donorsForm/' + response.data.id);
                  onScan.detachFrom(document);
                } else {
                  EventBus.$emit('hideThrobber');
                  EventBus.$emit("error", { msg: `Код ${sCode} не найден!` });
                }
              });
            },
            onKeyDetect: function (iKeyCode) {
              if(iKeyCode === 45) {
                onScan.simulate(document, '000203005');
              }
            }
        });
    } else if(this.filterQuery.redirectCode) {
      this.filterQuery.redirectCode = '';
      this.$emit('search', this.filterQuery);
    }
  },
  created() {
    EventBus.$emit('showThrobber');

    const self = this;
    if (this.query.patientId) {
      axios.get('/patients/' + this.query.patientId).then((response) => {
        self.patient = response.data;
        EventBus.$emit('hideThrobber');
      });
    } else {
      EventBus.$emit('hideThrobber');
    }
  },
  computed: {
    reset: function() {
      return {
          statuses: [2]
        };
    },
  },
  methods: {
    getStatusColorClass(row) {
      if(row.no_connection == 1) {
        return 'no-connection-status';
      }
      switch(row.status) {
        case 1: return 'new-status';
        case 2: return 'in-work-status';
        case 3: return 'waiting-status';
        case 4: return 'prepare-utilization-status';
        case 6: return 'in-work-confirmed-status';
        case 7: return 'utilization-status';
        case 8: return 'active-status';
        case 9: return 'delete-status';
        default: return '';
      }
    }
  },
};
</script>
